'use strict';
const angular = require('angular');

/*@ngInject*/
export function MailsService($resource) {
  return $resource('/api/mails/:id', {
    name: '@_id'
  },{
    getByType: {
      method: 'GET',
      url: "/api/mails/type/:type",
      isArray: true
    },
    update: {
      method: 'PUT'
    },
    send: {
      url: "/api/mails/send/:id",
      method: 'PUT'
    },
    archive: {
      url: "/api/mails/archive/:id/:cat",
      method: 'PUT'
    },
    contact: {
      url: "/api/mails/contact",
      method: 'POST'
    }
  });
}


export default angular.module('conduuApp.MailsService', [])
  .factory('MailsService', MailsService)
  .name;



// WEBPACK FOOTER //
// ./client/services/mails/mails.service.js